module.exports = __webpack_public_path__ + "static/media/ABC Reading Club.209c1703.png";